import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'
import { RestaurantRewardCard } from '@/features/restaurants/restaurant-reward-card'

export function RestaurantDetailRewards() {
    const { restaurant } = useRestaurantDetailContext()

    const rewards = restaurant?.loyalty?.rewards

    if (!rewards?.length) return null

    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.REWARDS}
            title="restaurants.detail.rewards.title"
        >
            <div className="flex gap-y-4 gap-x-8 md:flex-row flex-col">
                {rewards?.map((reward) => {
                    return (
                        <RestaurantRewardCard
                            key={'restaurant-detail-content' + reward.uuid}
                            reward={reward}
                        />
                    )
                })}
            </div>
        </RestaurantDetailSection>
    )
}
